const en = {
	aqqewad: 'The security password must be 6-20 characters',
	qsrzz: 'Please enter an integer',
	黄金: 'Gold',
	美元: 'Dollar',
	原油: 'Crude',
	数值: 'Numerical Value',
	caijinj: 'bonus',
	djlfjj: 'Submit ',
	sutfufk: 'The verification code will be sent to your email',
	hoafaa: 'Send code',
	reqawao: 'Email',
	renzyao: 'Certification requirements',
	weirenzz: 'Unauthenticated',
	dhjzg: 'L1 certification',
	shiabais: 'Withdrawal failed',
	chongzzi: 'Recharge failed',
	zhengsong: 'give away',
	shouyi: 'income',
	chenggong: 'success',
	lunm: 'wheel',
	mmcuowu: 'Password is incorrect',
	qmiia: 'The security password must be 6 digits',
	至尊: 'VVIP',
	贵宾: 'VIP',
	专业: 'Expert',
	普通: 'Normal',
	基础: 'Primary',
	gunqq: 'success',
	fwwq: 'Copy failed',
	fuz: 'Copied successfully',
	shangpin: 'Upload credentials',
	fuzz: 'copy',
	erwei: 'QR code',
	pipeii: 'Please enter address',
	pipei: 'Match address',
	shuruu: 'Enter amount',
	touzichenggong: 'Successful Investment',
	tzjebndyzhye: 'The investment amount cannot exceed the account balance',
	tzjebnxy: 'The investment amount cannot be less than1',
	qxztzlx: 'Please select investment type',
	shurujine: 'Enter Amount',
	huiyuan: 'User',
	moshi: 'Mode',
	touzi: 'To Invest',
	zhtz: 'Portfolio Investment',
	lsjl: 'History Record',
	lunjieguo: 'Round Result',
	sycj: 'Remaining Time',
	jxz: 'In Progress',
	ljcj: 'Recharge Now',
	tzze: 'Invest(today)',
	yffje: 'profit(today)',
	zxrs: 'Online Users',
	涨: 'Up',
	大涨: 'Up&Full',
	小涨: 'Up&Minor',
	跌: 'Down',
	大跌: 'Down&Full',
	小跌: 'Down&Minor',
	tjiao: 'Submit',
	xuaze: 'Choose a profile',
	textee21: 'Send international email to support-gold@fgold.org',
	textee20: 'Comments and Complaints:',
	textee19: 'Questions and Answers: Please contact International Online Customer Service',
	textee18: 'The Forex Gold USA team is dedicated to ensuring you have all the information you need to explore and utilize our platform to maximize your returns. If you have any questions, please feel free to contact us.',
	textee17: 'Every user is the most important to us.',
	textee16: 'Contact us',
	textee15: '4. Concealment and flexibility of operation',
	textee14: '3. Private placement of funds',
	textee13: '2. High return on investment',
	textee12: '1. Convenience of investment activities',
	textee11: 'Features:',
	textee10: 'As one of the leading international companies in the industry, Forex Gold USA has won over 30 prestigious awards worldwide. With our innovation and service, Forex Gold USA continues to strengthen its leading position year after year, both in mature and emerging markets.',
	textee9: 'To ensure an exceptional trading experience for its clients, Forex Gold USA provides profitable, long-term, and regularly updated platform optimizations for every client. Forex Gold USA provides high-quality services to users from over 110 countries worldwide.',
	textee8: 'Forex Gold USA is a convenient, discreet, and high-return investment and trading software. Quantum Fund invested $2 billion in collaboration with dozens of major global exchanges, including the New York Stock Exchange (USA), NASDAQ, and the London Stock Exchange (LDN). Through data mining, the software calculates the weighted average of major futures trading volumes to create investment products for gold, US dollars, and crude oil. Individual investors can invest by anticipating long and short positions, large and small price increases, large and small price drops, and small price increases. As of December 2023, Forex Gold USA has over 55.43 million users worldwide, with an average return of approximately 29.30%.',
	textee7: 'Forex Gold USA',
	textee6: '4. Crude oil, soybeans, sugar, etc.: Texas crude oil, Durant crude oil.',
	textee5: '3. Gold, silver and other precious metals: London gold, platinum, palladium, silver, copper, and other precious metals trading.',
	textee4: '2. Foreign exchange: USD/CNY (offshore RMB), EUR/USD, EUR/JPY, EUR/NZD, GBP/USD, USD/JPY, USD/CAD, etc. 24 hours.',
	textee3: 'On April 1, 2013, Nasdaq spent US$750 million (approximately HK$5.85 billion) in cash to acquire the electronic bond trading platform eSpeed from currency broker BGC Partners, allowing Nasdaq to enter the market with a daily trading volume of US$500 billion for the first time. If the revenue meets the target, Nasdaq will issue approximately 15 million common shares worth US$484 million over the next 15 years, bringing the potential value of the transaction to US$1.23 billion.',
	textee2: '1. Index futures: Nasdaq, Frankfurt Index, CAC-40, EU50, Nikkei, Hang Seng China Enterprises Index, ASX 200, Swedish Stock Exchange 30, etc., US Dollar Index USDOLLAR, Hang Seng Index, Dow Jones Industrial Average, FTSE 100, S&P 500. All products can be applied for simulation.',
	textee1: 'Forex Gold USA is a renowned global trading service provider specializing in financial investments in real-time international price fluctuations of gold, US dollars, and crude oil. Founded in 1997, the group has consistently maintained its integrity brand for over two decades, becoming the preferred choice for global investors through its strong reputation and premium services.By delivering synchronized market data via Nasdaq, US, London, and international financial centers, it provides users worldwide with comprehensive charts and trading analytics from specialized perspectives across diverse asset categories, enabling effortless transactions anytime.Zero spreads, daily trading signal推送, and exceptional user experience have earned Forex Gold USA over 30 global trading awards, making it the top choice for more than 55.43 million users worldwide.',
	anquan1: 'Change security password',
	touzijl: 'investment record',
	yirenz: 'Certified',
	ldn5: 'The final result of LDNs 20170508001 round is: 7+4+5=16 (increase) (slight increase)',
	ldn4: 'LDN collects data from dozens of major global exchanges, including the London Stock Exchange, and through data mining, calculates the weighted average of major futures commodity transactions to derive international real-time price fluctuations of gold, US dollars, and crude oil investment products. The time is 24 hours a day, and the value is updated every 5 minutes. The investment model is a simple investment model with 6 combinations, which are classified into the three price fluctuation values of gold, US dollars, and crude oil. The results are (0-13) for a drop, (14-27) for an increase, (0-6) for a big drop, (7-13) for a small drop, (14-20) for a small increase, and (21-27) for a big increase.',
	ldn3: 'LDN investment instructions：',
	ldn2: 'LDN is the result of the weighted average of international real-time price fluctuations of gold, US dollars, and crude oil investment products derived from the calculation of the weighted average of major futures commodity transactions by dozens of major global exchanges such as the London Stock Exchange in the UK. The investment results of the AQ combination are converted every 5 minutes. The final result is converted into the sum of three numbers (0-9), with a total of 28 results (0-27).',
	ldn1: 'What is LDN',
	usa5: 'The final result of USAs 20170508001 round is: 7+4+5=16 (increase) (slight increase)',
	usa4: 'USA collects data from dozens of major global exchanges such as the New York Stock Exchange, and through data mining, calculates the weighted average of major futures commodity transactions to derive the international real-time price fluctuations of gold, US dollars, and crude oil investment products. The time is 24 hours, and the value is updated every 3 minutes. The investment model is a simple investment model with 6 combinations, which are classified into the three price fluctuation value combinations of gold, US dollars, and crude oil. The results are (0-13) for a drop, (14-27) for an increase, (0-6) for a big drop, (7-13) for a small drop, (14-20) for a small increase, and (21-27) for a big increase.',
	usa3: 'USA investment instructions:',
	usa2: 'USA is the result of the weighted average of gold, US dollars, and crude oil investment products derived from the calculation of the weighted average of major futures commodity transactions through data mining. The investment results of the AQ combination are converted every 3 minutes to the weighted average of the international real-time price fluctuations. The final result is converted into the sum of three numbers (0-9), with a total of 28 results (0-27).',
	usa1: 'What is USA',
	nasd9: 'The final result of NASDAQs 20170508001 round is: 7+4+5=16 (up) (slight increase)',
	nasd8: 'The value assigned to the crude oil price fluctuation data at 09:05 on May 8, 2017 is: 5',
	nasd7: 'The value of the USD price fluctuation calculated at 09:05 on May 8, 2017 is: 4',
	nasd6: 'The value of the gold price increase and decrease calculated at 09:05 on May 8, 2017 is: 7',
	nasd5: 'For example：',
	nasd4: 'NASDAQ collects data from dozens of major global exchanges, including the Nasdaq Stock Exchange, and through data mining, calculates the weighted average of major futures commodity transactions to derive international real-time price fluctuations of gold, US dollars, and crude oil investment products. The time is 24 hours, and the value is updated every 1 minute. The investment model is a simple investment model with 6 combinations, which are classified into the three price fluctuation values of gold, US dollars, and crude oil. The results are (0-13) for a drop, (14-27) for an increase, (0-6) for a large drop, (7-13) for a small drop, (14-20) for a small increase, and (21-27) for a large increase',
	nasd3: 'NASDAQ Investment Description:',
	nasd2: 'NASDAQ is a global exchange that includes dozens of other exchanges. Through data mining, it calculates the weighted average of major futures commodity transactions to derive the international real-time price fluctuations of gold, US dollars, and crude oil investment products. The AQ investment results are calculated by taking the weighted average of each minute. The final result is converted into the sum of three numbers (0-9), for a total of 28 possible outcomes (0-27)',
	nasd1: 'What is NASDAQ?',
	text10: 'The higher the account level, the higher the return on investment will be；',
	text9: 'Account levels are divided into basic, ordinary, professional, VIP and supreme；',
	text8: 'If you invest $100 and the final result is a small drop, the return rate is $360；',
	text7: 'If you invest $100 and the market crashes, the return is $360；',
	text6: 'If you invest $100 and the price goes up slightly, the return is $360',
	text5: 'If you invest $100 and the price goes up, the return is $360;',
	text4: 'If you invest $100 and the final result is a decline, the return is $195;',
	text3: 'If you invest $100 and the final result is a rise, the return is $195;',
	text2: 'Investment (increase), (decrease), (large increase), (small increase), (large decrease), (small decrease)',
	text1: 'Low-risk portfolio investment return rate explanation',
	ldn: 'what is LDN ？',
	usa: 'what is USA ？',
	nasd: 'what is NASDAQ ？',
	text: 'Investment Rules Explanation',
	xitongxx: 'System messages',
	touzimx: 'Investment details',
	youxiao: 'Please enter a valid email address',
	liangan: 'The two security passwords entered are inconsistent',
	liang: 'The two passwords you entered do not match',
	qsryz: 'Please enter the correct digital verification code',
	tianxx: 'Please be sure to fill in your email address, otherwise you will not be able to pass the certification',
	yanzhengma: 'Please enter the verification code',
	youxiang: 'Mail',
	anquanmi: 'Confirm security password',
	anquan: 'Please enter a secure password',
	querenmma: 'Confirm Password',
	tijiao: 'submit',
	meyou: 'No account',
	meiyou: 'No account',
	zaixian: 'Online Chat',
	deglu: 'Login in',
	jichu: 'Primary',
	putong: 'Normal',
	zhuanye: 'Expert',
	guibin: 'VIP',
	chaoguibin: 'VVIP',
	anquanzhongxin: 'Security Center',
	renzhengzx: 'Certification Center',
	jiaoyiguize: 'trading rules',
	jinrisunyi: 'Todays earnings',
	zican: 'assets',
	jiaoyidating: 'Trade',
	zuiditouzi: 'Minimum',
	zuidijinru: 'Minimum Entry',
	hangqing: 'Quotes',
	jiaoyi: 'trade',
	qianbao: 'wallet',
	jiantizhongwen: 'English',
	xianlu: 'Line ',
	dianwei: 'Point',
	wodezichan: 'My assets',
	touzikuaixun: 'Investment News',
	jiaoyiyonghu: 'User',
	jiaoyipinglei: 'Category',
	danlunhuoli: 'Profit',
	jiaoyiriqi: 'Date',
	dengluhouchakan: 'View after login',
	shouye: 'Home',
	yucun: 'Prestore',
	zoushi: 'Trend',
	wode: 'Mine',
	jichulicai: 'Basic Financing',
	zishenlicai: 'Senior Financing',
	dashilicai: 'Master Financing',
	zhuanjialicai: 'Expert Financing',
	基础理财: 'Basic Financing',
	资深理财: 'Senior Financing',
	大师理财: 'Master Financing',
	专家理财: 'Expert Financing',
	huiyuanquanyi: 'Member benefits',
	zuoriyingli: 'Profit yesterday',
	zongzichan: 'Total Assets',
	chucunjin: 'Money',
	jinriyingli: 'Profit today',
	zhuanchu: 'Withdraw',
	cunru: 'Recharge',
	zhanghuxinxni: 'Account information',
	lishizhangdan: 'Historical bills',
	zijinminxi: 'Funding Details',
	renwuzhongxin: 'Mission center',
	xiaoxigonggao: 'News announcement',
	tuijianfenxiang: 'Recommended to share',
	huodongzhongxin: 'Activity Center',
	jibenziliao: 'Basic information',
	dengluzhanghao: 'Login account',
	nicheng: 'Nick name',
	shezhi: 'Settings',
	genggaixianlu: 'Change line',
	guanyuwomen: 'About us',
	xitongshezhi: 'System settings',
	yuyanshezhi: 'Language settings',
	tuichudenglu: 'Logout',
	bangdingyinhangka: 'Bind bank card',
	bangdingxuniqianbao: 'Bind virtual wallet',
	anquanma: 'Security code',
	xiugailenglumima: 'Modify login password',
	yinhangkaguanli: 'Bank card management',
	tianjiayinhangka: 'Add a bank card',
	xuniqianbaoguanli: 'Virtual wallet management',
	tianjiaxuniqianbao: 'Add virtual wallet',
	chiakren: 'Cardholder',
	yinhangkakahao: 'Bank card number',
	yinhangmingcheng: 'Bank name',
	yhkTps: 'Please bind the cardholder own bank card',
	nixiqianbaodizhi: 'Wallet address',
	xuniqianbaoleixing: 'Wallet Type',
	xnqbTps: ' Reminder: Please fill in the USDT address type, such as: trc20, erc20, omni. ',
	plchikaren: 'Please enter cardholder',
	plkahao: 'Please enter cardholder card number',
	plyinhangmingcheng: 'Please enter bank name',
	plqbdz: 'Please enter the virtual wallet address',
	plqblx: 'Please enter virtual wallet type',
	shezhianquanma: 'Set security code',
	yuananquanma: 'Original security code',
	xinanquanma: 'New security code',
	planquanma: 'Please enter the original security code',
	plxinanquanma: 'Please enter a new security code',
	queren: 'Confirm',
	quxiao: 'Cancel',
	anquanmaTps: ' Please set a security code, not the same as the bank card password',
	anquanmaTpsTow: ' Dear customer, this security code is the password when you transfer out. For security reasons, please try not to be the same as the login password',
	xiugaidenglu: 'Modify login password',
	jiumima: 'Old Password',
	xinmima: 'New password',
	querenmima: 'Confirm Password',
	pljiumima: 'Please enter old password',
	plxinmima: 'Please enter a new password',
	plquerenmima: 'Please enter the password again',
	wancheng: 'Complete',
	kaishitouzi: 'Start investing',
	kaiTps: 'When the current line is unavailable, try switching to other lines',
	zuiyou: 'Optimal',
	dangaqianxianlu: 'Current line',
	dangqianbanben: 'In the 2025 new user activity lottery delivery, users with activity quotas can pay attention to checking system messages',
	banquansuoyou: 'Copyright',
	yinglizhendong: 'Earnings shock',
	gensuixitong: 'Default',
	zhuanchujine: 'Amount',
	plzhuanchu: 'Please enter the transfer amount',
	zhuanchuTps: 'Tips: If you have any questions, please contact the platform customer service.',
	xuanzeyh: 'Please select a bank card for withdrawal',
	xuanzehb: 'Please select a virtual wallet for withdrawal',
	tijiaoshenqing: 'Submit application',
	shuruanquanma: 'Please enter security code',
	xianshangcunru: 'Online deposit',
	saomacunru: 'USDT',
	wangyincunru: "Banking deposit",
	shijian: 'Time',
	upshijian: 'Starting time',
	downshijian: 'End Time',
	wuTps: 'No data ~',
	jiazaicx: 'Reload',
	di: 'Period ',
	lun: 'Round',
	weiyingli: 'Unprofitable',
	yishouli: 'Accepted',
	zhuangtai: 'Status',
	chongzhi: 'Reset',
	riqi: 'Date',
	CapActive: {
		chongzhi: 'Recharge',
		tixian: 'Withdraw',
		goumai: 'Buy',
		yingli: 'Profit',
		zengsong: 'Give away',
		weitongguo: 'Did not pass',
		yitongguo: 'Passed',
		yijujue: 'Rejected',
	},
	zhanneixiaoxi: "Information",
	pingtaigonggao: 'Announcement',
	fuzhilanjie: "copy Link",
	denglu: 'Login',
	zhuce: 'Register',
	jizhumima: 'Remember',
	wangjimima: 'Forgot password',
	youkedenglu: 'Visitor login',
	zhucezhanghao: "Register account",
	plusername: 'Please enter user name',
	plpassword: 'Please enter password',
	wanchengzhuce: 'Complete',
	yiyouzhanghao: 'Have an account',
	qingdenglu: 'Please sign in',
	remenhuati: 'Hot topic',
	news1: 'Original',
	news2: 'Recommend',
	news3: 'Asset',
	renliulan: ' browse',
	hezhi: 'And value',
	lunshu: 'Period',

	做多: 'Many',
	做空: 'Short',
	多单: 'Many Single',
	多双: 'Many Double',
	空单: 'Short Single',
	空双: 'Short Double',
	平单: 'Flat Single',
	平双: 'Flat Double',
	极阴: 'Cathode',
	极阳: 'Anode',
	qi: '',
	juli: 'distance',
	lunjiezhi: 'end',
	yifengpan: 'Stop betting',
	yiguanbi: 'Closed',
	yonghu: 'User',
	danlunjiaoyi: 'Trade',
	caozuo: 'Operate',
	pljoin: 'Join the chat room successfully',
	pltingshou: 'Product has been discontinued',
	gengou: "Follow",
	quedinggengou: "Are you sure to follow the purchase?",
	wanjia: "player",
	leibie: "category",
	jine: "Amount",
	gouru: 'Buy',
	zanweigouru: 'Not yet purchased',
	qigou: ' purchase',
	gourushuliang: 'Purchase quantity',
	changgui: 'Conventional',
	shuzi: 'Number',
	yinglihezhi: 'Profit and value',
	shouyijieshao: 'Income',
	lijicunru: 'Deposit',
	kaihaojieguo: 'Record',
	kaihaoqushi: 'Trend',
	chanpingshuoming: 'Description',
	qingchuhuancun: 'clear cache',
	youke: 'Visitor',
	gongxi: 'Congratulations to ',
	zai: ' in the ',
	yingli: ' profit ',
	xiadanchenggong: 'successfully ordered',
	jiazaizhong: 'Loading...',
	guanbitg: 'closed, stop buying',
	xiangoudl: 'Only follow the current round',
	liaotiantip: 'The system has been banned, please choose to buy',
	tishi: 'Tip',
	zhidao: 'OK',
	zhuanchusb: 'Failed to transfer out',
	zhuanchusbs: 'Insufficient balance, transfer out failed',
	buyxq: 'Purchase details',
	orderNo: 'Bill No.',
	plan_name: 'Hall information',
	buyxx: 'Buy information',
	haoxx: 'Number selection details',
	buysj: 'Buy time',
	yilou: 'missing',
	fzjqb: 'Copied to clipboard',
	chanpin1: 'Sale time: every 3.5 minutes is a round, opening at 10:00AM on the same day and closing at 02:00AM the next day. ',
	chanpin2: 'There are 3 numbers from 0 to 9 in each round. The sum of the 3 numbers is the final result. You can invest in the result: Many, Short, Flat Single, Flat Double, Many Single, Many Double, Short Single, Short Double, Cathode, Anode, and number. ',
	Tips: {
		wjmm: 'Forgot your password, please contact customer service to modify it!',
		dlcg: 'Login successful',
		tjcg: 'Submitted successfully',
		zanwu: 'No data',
		buyizhi: 'The two passwords are inconsistent',
		zcbz: 'Your assets are insufficient, please deposit',
		pltxje: 'Please enter the withdrawal amount',
		zdtx: 'Minimum withdrawal 100',
		youke: 'Dear tourists: Please register as a full member and operate. ',
		szcg: 'set successfully',
	},
}
export default en;